// extracted by mini-css-extract-plugin
export default {"add-limit":"wWAnbyPozhdM_p6iOG3g","icon":"gpLPc3kyWDIka4U3uQGg","icon-disabled":"ChPe7nKeUZPLJKWgTCWg"};